module.exports = __webpack_public_path__ + "img/1.d9316e7f.png";